import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Callout } from '../../molecules';
export const CalloutTradeExpired = memo(({ onClose }) => {
    return (_jsx(Callout, { icon: "Info", title: "Your trade could not be completed", message: "Your trade could not be completed at this time, please try again.", ctas: [{ variant: 'clear', label: 'Dismiss', onPress: onClose }] }));
});
